import axios from "axios";

/**
 * 服务端日志记录参数接口
 */
export interface ServerLogParams {
    token: string; // 鉴权 token
    enverionment: "development" | "production";
    [key: string]: unknown; // 其他参数
}

/**
 * 调用服务端接口记录日志
 * @param params 请求参数，必须包含 token 字段
 * @returns Promise<void> 不影响主流程，错误会被捕获
 */
export async function reportLogger(params: ServerLogParams): Promise<void> {
    try {
        if (!params.token) {
            console.warn("[ServerLogger] token 参数缺失，跳过日志上报");
            return;
        }

        const baseUrl =
            params.enverionment === "production" ? "https://turbodesk.xfyun.cn" : "https://fetdev.iflysec.com";
        // 发送请求
        await axios.post(
            `${baseUrl}/api/engine/v2/log/collect`,
            {
                errorMsg: `${params.platform}发布成功，文章id:${params.postId} uid:${params.uid} accountId:${params.accountId}`,
                traceInfo: JSON.stringify(params),
            },
            {
                headers: {
                    token: params.token,
                    "Content-Type": "application/json",
                },
                timeout: 5000,
            },
        );
    } catch (error) {
        // 捕获所有错误，不影响主流程
        console.warn("[ServerLogger] 日志上报失败:", error instanceof Error ? error.message : error);
    }
}
